import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { PaginatorComponent } from './paginator/paginator.component';
import { TableVariant } from './table.model';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    standalone: true,
    imports: [PaginatorComponent],
    host: {
        class: 'block h-full w-full'
    }
})
export class TableComponent<T> {
    public items: InputSignal<T[]> = input<T[]>([]);
    public totalItems: InputSignal<number> = input(0);
    public pageSize: InputSignal<number> = input(10);
    public currentPage: InputSignal<number> = input(1);
    public pageChange: OutputEmitterRef<number> = output<number>();
    public pageSizeChange: OutputEmitterRef<number> = output<number>();
    public loading: InputSignal<boolean> = input(false);
    public variant: InputSignal<TableVariant> = input<TableVariant>('default');

    protected rowBg: Signal<string> = computed(() =>
        this.variant() === 'contrast' ? 'var(--base-3)' : 'var(--base-2)'
    );
    protected rowBgHover: Signal<string> = computed(() => 'var(--base-4)');
}
